<template>
  <div id="app" ref="app">
    <!--<img src="./assets/logo.png">-->
    <Headers style="z-index:999;"></Headers>
    <router-view v-wechat-title='$route.meta.title'></router-view>
    <Footers></Footers>
    <StatementDialog :visible="statementVisible" @close="statementVisible = false"></StatementDialog>
  </div>
</template>

<script>
import Headers from '@/components/Header';
import Footers from '@/components/Footer';
import StatementDialog from '@/components/StatementDialog';

// 严正声明弹窗 sessionStorage 标记（每次打开网站弹出一次，同一会话内切换页面不重复弹出）
var STATEMENT_SESSION_KEY = 'cs_statement_notice_20260924';

export default {
  name: 'App',
  data (){
    return{
      isIndex:true,
      statementVisible:false
    }
  },
  components:{
      Headers,
      Footers,
      StatementDialog
  },
   mounted(){
      // this.$refs.app.addEventListener("scroll",this.changeIndex,false)
      this.showStatementOnce();
    },
    watch:{
      $route (to,from) {
          // console.log(to)
        this.isIndex = to.fullPath == "/" ? false : true;
      }
    },
    methods: {
      showStatementOnce (){
        var shown = false;
        try {
          shown = window.sessionStorage.getItem(STATEMENT_SESSION_KEY) === '1';
        } catch (e) {
          shown = false;
        }
        if (!shown) {
          try {
            window.sessionStorage.setItem(STATEMENT_SESSION_KEY, '1');
          } catch (e) {}
          this.statementVisible = true;
        }
      }
    }
}
</script>


<style>
  body {
    padding: 0;
    margin: 0;
  }
    
  a{
    outline: none!important;
  }
  #app {
    text-align: center;
    color: #333333;
    width: 100%;
    min-width: 1148px;
    /*margin-top: 60px;*/
  }
  .wrap{
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  ul{
    padding-inline-start: 0px;
  }
  ul li{
    list-style: none;
  }
    .ccod_title{
    text-align: center;
    margin: 0;
    padding: 0;
  }
  .ccod_titles{
    text-align: center;
    margin: 0;
    padding: 0;
  }
  .line{
    width: 62px;
    height: 3px;
    display: inline-block;
    margin-top: 20px;
    background: #ff882f;
  }
  .flex{
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  /*.ccod-section-contact-map {
          width: 405px;
          height: 213px;
          float: right;
        }
    .amap-logo, .amap-copyright {
        display: none !important;
      }*/
</style>



// WEBPACK FOOTER //
// src/App.vue